import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  TransportManagementProfileItemBriefState,
  TransportManagementProfileItemBriefStateModel,
} from './transport-management-profile-item-brief.state';
import { TransportManagementProfileDetails, TransportManagementProfileModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import {
  TransportManagementProfileItemBriefClone,
  TransportManagementProfileItemBriefDelete,
  TransportManagementProfileItemBriefInitialState,
  TransportManagementProfileItemBriefLoad,
  TransportManagementProfileItemBriefSave,
} from './transport-management-profile-item-brief.actions';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class TransportManagementProfileItemBriefFacade implements LoadDataFacade, SetInitialStateFacade {
  profileId$: Observable<number> = this.store.select(TransportManagementProfileItemBriefState.getProfileId);
  profile$: Observable<TransportManagementProfileItemBriefStateModel> = this.store.select(
    TransportManagementProfileItemBriefState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(TransportManagementProfileItemBriefState.getLoaded);

  constructor(private store: Store) {}

  loadAll(transportManagementProfileId: number): void {
    this.store.dispatch(new TransportManagementProfileItemBriefLoad(transportManagementProfileId));
  }

  saveProfile(profile: Partial<TransportManagementProfileDetails>): void {
    this.store.dispatch(new TransportManagementProfileItemBriefSave(profile));
  }

  cloneProfile(data: Partial<TransportManagementProfileModel>): void {
    this.store.dispatch(new TransportManagementProfileItemBriefClone(data));
  }

  deleteProfile(profileId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new TransportManagementProfileItemBriefDelete({ dialog, profileId }));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportManagementProfileItemBriefInitialState());
  }
}
